export enum tabTypes {
  generalPlan = 'generalPlan',
  map = 'map',
  panorama = 'panorama',
}

export type TTabId = keyof typeof tabTypes;
